import { AmmunitionStockEventService } from './ammunition-stock-event.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { AMMUNITION_STOCK_EVENT_TYPE, AmmunitionStockEvent } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class AmmunitionStockEventResolverBase implements Resolve<AmmunitionStockEvent> {

  constructor(protected service: AmmunitionStockEventService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AmmunitionStockEvent> {
    const key: number = AMMUNITION_STOCK_EVENT_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



